var _polygon, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _rect4, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse2, _path0, _path1, _ellipse3, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGirlIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b2975d1f-ae6a-4396-8916-b342c341cf92",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 458.6918,
    height: 782.51678,
    viewBox: "0 0 458.6918 782.51678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Designer girl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "245.882 401.346 250.892 405.064 193.947 493.101 182.761 498.933 245.882 401.346",
    fill: "#002e4e",
    stroke: "#002e4e",
    strokeMiterlimit: 10,
    strokeWidth: 1.12412
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 381.559 197.236 139.002 217.293 152.818 22.229 398.446 0 381.559",
    fill: "#c5cae9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.157 251.209 160.463 264.374 122.019 310.174 102.621 297.215 139.157 251.209",
    fill: "#1a237e"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.766 280.691 213.672 390.192 187.485 391.793 131.72 296.226 146.766 280.691",
    fill: "#1a237e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.56646,
    y: 389.23484,
    width: 195.84262,
    height: 9.21103,
    fill: "#1a237e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.18148,
    y: 407.47616,
    width: 24.51515,
    height: 318.61221,
    fill: "#1a237e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 277.21729,
    y: 407.47616,
    width: 22.84366,
    height: 318.61221,
    fill: "#1a237e"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.62153,
    y: 396.53826,
    width: 353.29892,
    height: 18.93378,
    fill: "#536dfe"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.53669,
    cy: 85.23787,
    rx: 47.00964,
    ry: 47.88601,
    fill: "#ff6584"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.93712,238.50062a8.76488,8.76488,0,0,0-10.46992,2.72045c-4.17536,5.30933-9.8727,16.96-7.68556,39.81382l8.47085,88.5132,1.34845,89.22049S715.34289,499.90292,734,499.515s-15.452-39.4004-15.452-39.4004,4.73025-70.78138,2.78612-91.09588C719.52169,350.08075,737.4623,250.25275,710.93712,238.50062Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M687.934,198.00388l-10.69526,29.5262,15.28889,4.81067,2.14684,42.84757-37.90692-20.7986-19.09218-21.42951-2.3823-16.4447s14.72275-2.60087,20.076-35.71865Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M759.70607,444.68582s66.88151,68.4026,49.64746,104.46956-101.34139,162.3227-101.34139,162.3227l-22.50029-29.18936s22.11638-16.379,32.41647-54.76422,33.61324-64.89654,40.494-74.33225-64.60567-75.46582-58.29109-92.31306S759.70607,444.68582,759.70607,444.68582Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M759.70607,444.68582s66.88151,68.4026,49.64746,104.46956-101.34139,162.3227-101.34139,162.3227l-22.50029-29.18936s22.11638-16.379,32.41647-54.76422,33.61324-64.89654,40.494-74.33225-64.60567-75.46582-58.29109-92.31306S759.70607,444.68582,759.70607,444.68582Z",
    transform: "translate(-361.65887 -62.48322)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M717.68159,690.63673s6.9872,14.07221,4.88234,19.688-13.14206,38.0369-13.14206,38.0369,11.75179,46.96162,3.22588,45.91668-39.38114-32.72671-38.01339-44.30651l3.93227-33.29194-9.55172,7.63992-12.15822-19.11127,16.94534-21.418s18.19536-19.79642,23.8793-19.09979S717.68159,690.63673,717.68159,690.63673Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M704.39414,461.40166l4.48716,10.829,18.84546,84.54175s7.5001,9.72979,5.15977,41.7484,37.80865,155.88206,37.80865,155.88206l1.35649,25.12955-24.15674-2.96065L731.42051,745.184s-6.18558-33.06355-24.252-63.17792S689.1247,578.473,689.1247,578.473L640.50306,465.31861l38.26012-18.80571Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M762.458,738.709s7.2759-.57669,8.35495,2.49241,22.831,63.00377,22.831,63.00377,41.36827,40.3124,21.13254,40.76917-54.16839-5.17045-59.90557-17.621-12.38243-29.41775-12.38243-29.41775l-2.05162,17.36971-16.026-10.77472s-8.96306-58.36726,1.49674-61.4906S762.458,738.709,762.458,738.709Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M738.06062,408.25908s16.93409,15.2913,15.34214,16.56462,9.605,4.114,7.50009,9.72979,9.48723,17.31548,3.80329,16.61885-27.73582-9.273-52.128,14.16921l-4.263-.52247.56614,7.41153s-17.6712-21.25536-63.32494,11.32849c0,0-15.11793-6.25815-13.01307-11.87389s-24.55191-11.81966-10.15984-48.23493S681.339,388.09141,681.339,388.09141Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M646.319,220.80371s-7.32913-11.17727-11.76306-10.25226-28.67663.367-32.54441,8.70349,14.55074,94.81812,11.591,107.67125-18.67755,109.31151-5.15157,116.843,29.339-28.70965,29.339-28.70965,42.52307-18.28325,78.61383-6.51782S741.4155,404.265,741.4155,404.265s-25.85517-25.19525-21.92289-58.48718,5.6952-36.01274-.95006-52.9799c0,0-1.18552-26.577-.33068-33.81441s6.14361-15.39976,2.22259-18.81718-44.61667-12.81036-44.61667-12.81036,20.6309,8.40224,11.25015,14.59468S646.319,220.80371,646.319,220.80371Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.8267,
    cy: 108.42117,
    rx: 34.34959,
    ry: 34.98996,
    fill: "#ffb8b8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M610.28424,215.2033a8.76963,8.76963,0,0,1,10.407,2.96038c4.05671,5.40394,9.49456,17.18257,6.80181,39.98031L617.064,346.44l-3.32416,89.16679s2.14684,42.84757-16.49693,42.031.52416-41.05178.52416-41.05178-3.16139-70.87208-.76783-91.13673C599.23058,326.55775,583.50552,226.34285,610.28424,215.2033Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ffb8b8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M656.65793,62.48322a25.7585,25.7585,0,0,0,14.827,10.38286c10.3682,2.82813.08469,18.69912.08469,18.69912s3.73946-5.77127-1.6542-11.8832S655.842,69.39149,656.65793,62.48322Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ff6584"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.74811,
    cy: 32.88921,
    rx: 13.10105,
    ry: 13.34528,
    fill: "#ff6584"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M656.68046,106.558c10.68021-4.11494,28.46372-6.20142,37.61288-4.77516l-1.25477-9.33307c-8.79577,4.63067-26.49768,6.8068-37.61288,4.77516Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M677.34667,109.89873s13.38521,22.6792,44.51035,31.16916.25425,56.13437.25425,56.13437,11.22577-17.32524-4.96588-35.67312S674.89715,130.63722,677.34667,109.89873Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ff6584"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M676.28435,108.5206s-12.8588,31.1509-26.97577,34.096-13.04621,52.16663,9.0305,59.54762c0,0-16.09794-28.85575-2.33789-48.208S678.45275,119.30571,676.28435,108.5206Z",
    transform: "translate(-361.65887 -62.48322)",
    fill: "#ff6584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlIllustration);
export default __webpack_public_path__ + "static/media/girl-illustration.28c5f19a8b41dd032747334ab764b831.svg";
export { ForwardRef as ReactComponent };